import React, { Component } from 'react';
import './FloatingNavPanel.css';

class FloatingNavPanel extends Component {
  handleMouseUp(nodeId) {
    const node = document.getElementById(nodeId);
    if (node) {
      window.scrollTo(0, node.offsetTop);
    }
  }

  render() {
    const { navigationItems, currentNavigationItemIndex } = this.props;
    const activeNavItemStyle = {
      backgroundColor: 'blue',
      color: 'cyan'
    };
    const renderedNavigationItems = navigationItems.map(
      (navigationItem, index) => (
        <li key={`navpanel-${navigationItem.name}`} style={index+1 === currentNavigationItemIndex ? activeNavItemStyle : undefined }
            onMouseUp={() => this.handleMouseUp(navigationItem.id)}
        >
          {navigationItem.name}
        </li>
      )
    )
    return (
      <div className="NavPanel">
        <ul>
          {renderedNavigationItems}
        </ul>
      </div>
    )
  }
}

export default FloatingNavPanel;



// WEBPACK FOOTER //
// ./src/FloatingNavPanel.js